<template>
  <div id="app" class="us">
    <!-- <keep-alive include="businessAll,myBusiness"> -->
    <router-view />
    <!-- </keep-alive> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>
